
/* ============================== src/components/discussion/ReactionPicker.jsx ============================== */
// src/components/discussion/ReactionPicker.jsx
import { useCallback } from "react";
import { Emoji } from "emoji-picker-react";
import { REACTIONS } from "../../utils/reactions";
import { EMOJI_STYLE, EMOJI_SIZE_PICKER, getEmojiUrl } from "./emojiStyle";

/**
 * Панель выбора реакции. Эмодзи рисуются компонентом <Emoji> из
 * emoji-picker-react. Стиль, размер и URL спрайтов приходят из
 * общего emojiStyle.js: тот же стиль используется в CommentReactions,
 * а getEmojiUrl - чтобы спрайты грузились из public/emoji/apple/,
 * а не с внешнего CDN.
 */
export default function ReactionPicker({ containerRef, activeEmoji, onPick }) {
  const handleContainerClick = useCallback((e) => e.stopPropagation(), []);

  return (
    <div
      ref={containerRef}
      className="reaction-picker"
      onClick={handleContainerClick}
      role="toolbar"
      aria-label="Выбор реакции"
    >
      {REACTIONS.map(({ emoji, unified, label }) => {
        const isActive = activeEmoji === emoji;
        return (
          <button
            key={emoji}
            type="button"
            className={`reaction-pick-btn${isActive ? " on" : ""}`}
            onClick={() => onPick(emoji)}
            aria-label={label}
            aria-pressed={isActive}
            title={label}
          >
            <Emoji
              unified={unified}
              size={EMOJI_SIZE_PICKER}
              emojiStyle={EMOJI_STYLE}
              getEmojiUrl={getEmojiUrl}
              lazyLoad
            />
          </button>
        );
      })}
    </div>
  );
}
